// extracted by mini-css-extract-plugin
export default {"myFoorer":"footer_myFoorer__yC-6o"};